import { gql } from '@apollo/client';

export const UPSERT_TAG = gql`
  mutation UpsertTag(
    $create: TagCreationInput!
    $update: TagUpdateInput!
    $where: TagUniqueFilterInput!
  ) {
    upsertTag(create: $create, update: $update, where: $where) {
      id
      title
      slug
      type
      relationId
    }
  }
`;
